import React, { Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Skeleton from '@material-ui/lab/Skeleton';
import Grid from '@material-ui/core/Grid';
import ClassNames from 'classnames';
import Box from '@material-ui/core/Box';
import { hidePageSidebar } from 'utils/embedded';
import AppContainer from 'components/AppContainer';

const useStyles = makeStyles(theme => ({
  root: {
    background: '#FFFFFF',
  },
  leftPanel: {
    width: 398,
    'box-shadow': '0 2px 24px 10px rgba(0,0,0,0.05)',
    [theme.breakpoints.down('md')]: {
      width: 300,
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  rightPanel: {
    width: 'calc(100% - 398px)',
    padding: 56,
    [theme.breakpoints.down('md')]: {
      width: 'calc(100% - 300px)',
      padding: 40,
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: 18,
    },
  },
  container: {
    marginTop: 21,
  },
  mb12: {
    marginBottom: 12,
  },
  contentInfo: {
    background: '#fff',
    marginBottom: 30,
  },
  mx50: {
    marginLeft: 50,
    marginRight: 50,
  },
  mt50: {
    marginTop: 50,
  },
  white: {
    background: '#fff',
  },
  fullPage: {
    width: '100%',
    paddingTop: 20,
  },
}));

function PageResourceSkeleton() {
  const classes = useStyles();
  const showSidebar = !hidePageSidebar();
  const rightPanelSkeleton = () => (
    <Grid item xs={12}>
      <Grid item xs={12}>
        <Grid container spacing={2} className={classes.contentInfo}>
          <Grid item xs={12} sm={3}>
            <Skeleton variant="rect" height={200} />
          </Grid>
          <Grid item xs={12} sm={9}>
            <Skeleton width={60} />
            <Skeleton variant="rect" height={30} />
            {Array.from(new Array(10)).map((_, index) => (
              <Skeleton
                variant="rect"
                height={30}
                className={classes.mb12}
                key={`mid-${index}`}
              />
            ))}
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={2} className={classes.contentInfo}>
          <Grid item xs={12}>
            <Skeleton width={100} />
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              {Array.from(new Array(3)).map((_, index) => (
                <Grid item xs={4} key={`bottom-${index}`}>
                  <Skeleton variant="rect" height={348} />
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
  if (showSidebar) {
    return (
      <Box component="div" display="flex" className={classes.root}>
        <Box component="div" className={classes.leftPanel}>
          <Grid item xs={12}>
            {Array.from(new Array(4)).map((_, index) => (
              <Fragment key={`top-${index}`}>
                <Skeleton
                  variant="rect"
                  height={81}
                  className={ClassNames(
                    classes.mb12,
                    classes.mx50,
                    classes.mt50,
                  )}
                />
                <Skeleton
                  variant="rect"
                  className={ClassNames(classes.mb12, classes.mx50)}
                />
                <Skeleton
                  variant="rect"
                  className={ClassNames(classes.mb12, classes.mx50)}
                />
              </Fragment>
            ))}
          </Grid>
        </Box>
        <Box component="div" className={classes.rightPanel}>
          {rightPanelSkeleton()}
        </Box>
      </Box>
    );
  }
  return (
    <AppContainer>
      <Box component="div" className={classes.fullPage}>
        {rightPanelSkeleton()}
      </Box>
    </AppContainer>
  );
}

export default PageResourceSkeleton;
